    <!-- start circle  -->
   <div class="head-cont">
    <div class="circle-header d-flex justify-content-center w-100" [class]="item.color">
      <span class="fg-color1"  class="material-icons d-flex justify-content-center align-items-center"  >{{item.icon}}</span>
    </div>
   </div>